var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pricing-header px-3 py-6 pt-md-5 pb-md-4 mx-auto text-center border-top"},[_c('h3',[_vm._v(_vm._s(_vm.$t('banner1')))]),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('banner2a')))]),_vm._v(" "+_vm._s(_vm.$t('banner2b')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }